import { CalendarRoutePaths } from '$features/calendar/routes/protected'
import { ClientRoutePath } from '$features/clients/routes/protected'
import { ServiceRoutePath } from '$features/services/routes/protected'
import { OnboardingWizardConfig } from '../types'
import { SettingsRoutePath } from '$features/settings/routes/protected'

export const DEFAULT_ONBOARDING_WIZARD_CONFIG: OnboardingWizardConfig = {
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Tailly!',
      description: 'Let\'s get you set up with everything you need to manage your dog grooming business.',
    },
    {
      id: 'contact-information',
      title: 'Set Up Your Contact Information',
      description: 'Set your business phone number and email address so that your clients can easily reach you. This information is displayed all transactional emails, such as appointment confirmations, cancellations, and reminders.',
      route: SettingsRoutePath.Settings,
    },
    {
      id: 'create-services',
      title: 'Create Your Services',
      description: 'Add the grooming services you offer to your clients.',
      route: ServiceRoutePath.Services,
    },
    {
      id: 'add-clients',
      title: 'Add Your First Clients',
      description: 'Create your client profiles by adding their and their pets\' information. Additional pet details can be added later by navigating to their profile.',
      route: ClientRoutePath.Clients,
    },
    {
      id: 'schedule-appointments',
      title: 'Schedule Appointments',
      description: 'Schedule your first appointment. Simply click on an available time slot in the calendar and fill out the form.',
      route: CalendarRoutePaths.Calendar,
    },
    {
      id: 'complete',
      title: 'You\'re All Set!',
      description: 'That is all you need to get started with managing your appointments!',
    },
  ],
  persistState: true,
}
